<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <base-logo class="main-logo"></base-logo>

            <router-view></router-view>

            <div
                v-if="!$route.meta.noFooterBar == true"
                class="contact-link text-center"
            >
                Can’t access your account?
                <router-link to="/contact-us">Contact us</router-link>
            </div>
            <div
                v-if="!$route.meta.noFooterBar == true"
                class="contact-link register-now text-center d-none"
            >
                Are you a customer?
                <router-link to="/public-registration"
                    >Register now</router-link
                >
            </div>
        </div>

        <base-footer></base-footer>
    </div>
</template>

<script>
export default {
    components: {},
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {}
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {}, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
